import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
let token = window.token;
const SaveWebView = createAsyncThunk("SaveWebView", async (data) => {
  let response = null;
  try {
    response = await axios.post("/qrvisualization/save-web-view/", {
      id: data[0],
      image: data[1],
      token: token,
    });
  } catch (error) {
    response = error.response;
  } finally {
    return response.data;
  }
});

export default SaveWebView;
